import { render, staticRenderFns } from "./MassiveResendForm.vue?vue&type=template&id=a3ba310e&scoped=true&"
import script from "./MassiveResendForm.vue?vue&type=script&lang=js&"
export * from "./MassiveResendForm.vue?vue&type=script&lang=js&"
import style0 from "./MassiveResendForm.vue?vue&type=style&index=0&id=a3ba310e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ba310e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InvitationSuccess: require('/workspace/components/Invitation/InvitationSuccess.vue').default})
